import React from "react";
import "./_styles.scss";

export default function AppLogo() {
  return <div className="app-logo"></div>;
}
